import type { ZoningType, ZoneDocumentsGroupedResponse } from '@popety-io/types'
import { apiClient, API_BASE_URL } from './apiClient'

/**
 * Public zoning service for fetching zone documents without authentication.
 * Zone documents (regulations, maps) are public data.
 */
export const getZoneDocuments = async (
  type: ZoningType,
  id: string
): Promise<ZoneDocumentsGroupedResponse> => {
  const response = await apiClient.get<ZoneDocumentsGroupedResponse>(
    `/zoning/${type}/${id}/documents`
  )
  return response.data
}

/**
 * Transform a PDF URL through the API proxy to bypass CORS restrictions.
 * External government PDFs don't allow cross-origin fetch.
 */
export const getPdfProxyUrl = (url: string): string => {
  return `${API_BASE_URL}/zoning/pdf-proxy?url=${encodeURIComponent(url)}`
}

export const publicZoningService = {
  getZoneDocuments,
  getPdfProxyUrl,
}
